(function () {
    angular
        .module('date-and-time.dir',[])
        .directive('dateAndTime', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService','CANVAS_OPTS', 'timezoneFactory', 'plumbService', '$timeout', dateAndTime]);

    //Website Engagement Directive
    function dateAndTime($rootScope, $compile, $templateCache, helpers, canvasService, CANVAS_OPTS, timezoneFactory, plumbService, $timeout) {

        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function () {

                    //If form data is missing data to be filled
                    if($scope.dataFilledCorrectly() === false){
                        var errors = {
                            selectedListError: $scope.selectedListError,
                            errorTime: $scope.errorTime,
                            errorTimezone: $scope.errorTimezone
                        };

                        $rootScope.$emit('displayEntryDateTimeModalError', errors);

                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }

                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));
                    }
                    //Else we proceed to save and create new elements
                    else {
                        //Tracking event Intercom Date and Time
                        Intercom('trackEvent', 'AP - Started with date/time');
                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);
                        //Displays th form data
                        $scope.displayList = false;
                        $rootScope.$emit('hideEntryDateTimeModal');
                        //Displays action menu
                        $scope.displaySubMenu = false;
                        //Hides Error
                        $scope.displayError = false;
                        $scope.selectedListError = false;
                        $scope.errorTime = false;

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), $scope.isElegibleForUpdate);
                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                //Validates if data is filled correctly or not

                $scope.dataFilledCorrectly = function () {

                    var isClean = true,
                        lists = $scope.connections.data.selectedList;
                    $scope.selectedListError = false;
                    $scope.errorTime = false;
                    $scope.errorTimezone = false;

                    if (!$scope.connections.data.time) {
                        $scope.errorTime = true;
                        isClean = false;
                    }

                    if (lists.length === 0) {
                        $scope.selectedListError = true;
                        isClean = false;
                    }

                    if (!$scope.connections.data.timezoneName) {
                        $scope.errorTimezone = true;
                        isClean = false
                    } else if (lists.length > 0) {

                        for (var item in lists){
                            var contacts = helpers.getContactsFromList(lists[item], $scope.contactListData);
                            if (contacts > 200000) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.610'), 'error');
                                $scope.selectedListError = true;
                                isClean = false;
                            }
                        }
                    }

                    if(!isClean) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return isClean;
                };

                //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
                $scope.toggelListItem = function (listItem) {
                    var index = $scope.connections.data.selectedList.indexOf(listItem);
                    if (index > -1) {
                        $scope.connections.data.selectedList.splice(index, 1);
                    } else {
                        $scope.connections.data.selectedList.push(listItem);
                    }

                    if ($scope.connections.data.selectedList.length) {
                        $scope.selectedKey = $scope.translate('commons.editSelection');
                    } else {
                        $scope.selectedKey = $scope.translate('commons.selectList');
                    }
                };

                $scope.setLastElem = function(evt) {
                    plumbService.setLastElemClicked($(evt.target).parents('div.shape').attr('id'));
                };

                $scope.menuPos = {
                    left: 440
                };
                $scope.toggleConnectionMenu = function (event) {
                    if($rootScope.connections && $rootScope.connections.length > 1) {
                        $scope.menuPos.left = 200;
                    } else {
                        $scope.menuPos.left = 440;
                    }

                    //Move Canvas when element is close to the edge
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideEntryDateTimeModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryDateTimeModal', $scope.connections);
                            } else if ($scope.connections.data.selectedList.length === 0 || !$scope.connections.data.time) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $scope.displayList = true;
                                $scope.displaySubMenu = false;
                                $rootScope.$emit('displayEntryDateTimeModal', $scope.connections);
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $scope.$broadcast('setMenuDefaults');
                                $rootScope.$emit('hideEntryDateTimeModal');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideEntryDateTimeModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayEntryDateTimeModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {};

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $rootScope.$emit('displayEntryModal', 'isDateTimeFormDisplayed', $scope.connections);
                    }

                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function(evt) {
                    if ($scope.displayList || $scope.displaySubMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.getSelectedText = (desc) => {
                    if ($scope.connections.data.selectedList.length === 1) {
                        for (var item in desc) {
                            desc = helpers.getContactListItem(desc[item], $scope.contactListData);
                        }

                        return desc;
                    } else {
                        var lists = [];

                        for (var i = 0; i < desc.length; i++) {
                            lists.push(helpers.getContactListItem(desc[i], $scope.contactListData));
                        }

                        return lists.join().replace(/,/g, '<br />');
                    }
                };

                $scope.parseDescription = function(desc, selected) {
                    if (desc && typeof desc === 'object'){
                        var descriptionCheck = false;
                        for (var item in desc){
                            if(desc[item]) {
                                $scope.descriptionEmpty = false;
                                descriptionCheck = true;
                                //Lists that are currently selected on the node
                                var totalLists = $scope.connections.data.selectedList.length;
                                desc = helpers.getContactListItem(desc[item], $scope.contactListData);

                                //One list selected and > 19
                                if ( totalLists === 1 && desc.length > 15) {
                                    desc = desc.slice(0, 15) + '...';
                                //More than one selected
                                } else if (totalLists > 1) {
                                     desc = totalLists +  " " + $scope.translate('commons.selectedList');
                                //One selected but < 19
                                }  else if (totalLists === 1 && desc.length < 15) {
                                    desc = desc;
                                }

                                break;
                            }
                        }
                        if(!descriptionCheck) {
                            $scope.descriptionEmpty = true;

                            if (selected === 'showSelectedList') {
                                return '';
                            } else {
                                return $scope.translate('commons.enterDetails');
                            }

                        }

                    } else {
                        $scope.descriptionEmpty = true;

                        if (selected === 'showSelectedList') {
                            return '';
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                $scope.parseDescriptionMenu = function(desc) {
                    if (desc && typeof desc === 'object'){
                        for (var item in desc){
                            desc = helpers.getContactListItem(item, $scope.contactListData);
                            desc = desc.slice(0, 19) + '...';
                            break;
                        }

                    }else {
                        return '...';
                    }

                    return desc;
                };

                $scope.deleteEntry = function() {
                    var idx = $rootScope.unsavedData.indexOf($scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements($scope.connections);
                    $scope.$emit('displayJourney', true);

                    var shapeDelete;
                    shapeDelete = angular.element(document.querySelector('#step-placeholder' + $scope.connections.id));
                    jsPlumb.detachAllConnections(shapeDelete);
                    shapeDelete.remove();

                    $rootScope.deletedEntry = true;
                };

                $scope.contMenu = 0;
                $scope.validClickingArea = function() {
                    $scope.contMenu = 0;
                };
                $scope.$on('hideDateTimeModal', function() {
                    if($scope.modalWindow) {
                        if ($scope.contMenu === 0) {
                            $scope.contMenu = 1;
                        }else {
                            $scope.hideModal();
                            $scope.contMenu = 0;
                        }
                    }else {
                        $scope.contMenu = 0;
                    }
                });

                //Check RootScope connection to check if there is only an Entry on the Canvas.
                //We listen the saveJourneyStorage function on Canvas Service.
                $timeout(function() {
                    $rootScope.$watch('conn', function(){
                        if($scope.connections && $scope.connections.id && document.getElementById($scope.connections.id)) {
                            if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                                setTimeout(() => {
                                    plumbService.simpleConnect($scope.connections.id, 'step-placeholder' + $scope.connections.id, 'rgba(207, 207, 218, 1)');
                                }, 100);
                            }else {
                                let arrowConn = angular.element(document.querySelector('#' + $scope.connections.id));
                                jsPlumb.detachAllConnections(arrowConn);
                            }
                        }
                    });
                }, 1000);
            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.contactListData = $rootScope.contactListData;
                scope.timeZones = timezoneFactory.get();

                // load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections) {
                        if (document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;

                    ///Global scope data initialization
                    scope.isElegibleForUpdate = scope.connections.isElegibleForUpdate || false;
                    delete scope.connections.isElegibleForUpdate;

                    scope.selectedKey = scope.translate('commons.selectList');
                    if(scope.connections.data.selectedList.length) {
                        scope.selectedKey = scope.translate('commons.editSelection');
                    }

                    //Load Template
                    var template = angular.element($templateCache.get('entry/date-and-time')),
                        canvasEl = angular.element(document.querySelector('.canvas'));

                    canvasEl.append(template);

                    scope.$apply(() => {
                        $compile(template)(scope);
                    });

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveEntryDateTimeData' + scope.connections.id, function(evt, conn) {
                        scope.selectedList = $rootScope.selectedList;
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                        scope.connections.wasSave = true;

                        $timeout(function () {
                            scope.connections.wasSave = false;
                        }, 1500);
                    });

                    scope.save();
                    scope.connections.wasSave = false;

                    $timeout(() => {
                        if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                            setTimeout(() => {
                                plumbService.simpleConnect(scope.connections.id, 'step-placeholder' + scope.connections.id, 'rgba(207, 207, 218, 1)');
                            }, 100);
                        }
                    }, 200);

                    $rootScope.$emit('closeMenus', true);
                    plumbService.setInitDragConnect(scope.connections);
                }

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }

}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/date-and-time.js